<!-- Labels stay in the DOM in both states and fade with the rail. An @if around them took the
     row's height with them, which is exactly the jump the fixed row heights in the scss exist to
     prevent — see the two invariants at the top of that file before adding one back. -->
<div class="sidebar" [class.is-collapsed]="!showNav()">
  <div class="sidebar--header">
    <div class="sidebar--header--icon" (click)="toggleShowNav()"
         [title]="showNav() ? 'Collapse' : 'Expand'">
      <span class="material-symbols-outlined">dock_to_right</span>
    </div>
    <div class="sidebar--header--title prevent-select" (click)="navigateToHomePage()">
      FridayTech
    </div>
  </div>

  <div class="sidebar--content">
    @for (item of sideBarItems; track item.id) {
      <div
        class="sidebar-item"
        [class.item-selected]="isSelected(item)"
        [title]="showNav() ? '' : item.name"
        (click)="selectSideBarItem(item)"
      >
        <span class="sidebar-item--icon material-symbols-outlined">{{ item.googleIcon }}</span>
        <div class="sidebar-item--label">{{ item.name }}</div>
      </div>
    }
  </div>

  <div class="sidebar--footer">
    <!-- your own login and password (docs/ui/my-account.md); absent until argus signs in as an employee -->
    @if (myAccount) {
      <button type="button" class="sidebar-signout" (click)="openMyAccount()" [title]="showNav() ? '' : 'My account'">
        <span class="sidebar-item--icon material-symbols-outlined">manage_accounts</span>
        <div class="sidebar-item--label">My account</div>
      </button>
    }
    <!-- Sign out lives here rather than in a top bar: one piece of chrome, and the vertical
         space goes back to the data. Collapsed, the icon stands alone with a title — a door
         with an arrow needs no gloss. -->
    <button type="button" class="sidebar-signout" (click)="logOut()"
            [title]="showNav() ? '' : 'Sign out'">
      <span class="sidebar-item--icon material-symbols-outlined">logout</span>
      <div class="sidebar-item--label">Sign out</div>
    </button>

    <!-- Reports the build, it does not switch it: Argus has one baseUrl per build. Both states
         are rendered and stacked in one fixed box, swapped by opacity alone — the block cannot
         resize, so Sign out above it cannot move. -->
    <div class="sidebar--env" [class.prod]="isProd"
         [title]="showNav() ? '' : envName + ' → ' + backendHost">
      <div class="env-full">
        <div class="env-name">{{ envName }}</div>
        <div class="env-host">{{ backendHost }}</div>
      </div>
      <div class="env-tag" aria-hidden="true">{{ envTag }}</div>
    </div>
  </div>
</div>
